unit f_visitemodifica;

{$mode objfpc}

interface

uses
  Classes, SysUtils, js, web, un_widget, un_tquery, w_table, un_generator, f_selezione;

type

  { TFrmVisitemodifica }

  TFrmVisitemodifica = class(TWidget)
    nuovorecord :String;
    idtrasporto:integer;
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
    procedure modifica_click(Event: TJSEvent); async;
    procedure chiudi_click(Event: TJSEvent); async;
    procedure elimina_click(Event: TJSEvent); async;

  private

  published
    procedure idfruitore_click; async;
    procedure idfruitore2_click; async;
    procedure CompilaCampi; async;
    QrySeleziona: TQuery;
    QryVisite: TQuery;
    QryTrasporti: TQuery;
    dtdata: TJSHTMLSelectElement;
    horaarrivo: TJSHTMLInputElement;
    idfruitore: TJSHTMLInputElement;
    dsfruitore: TJSHTMLInputElement;
    dsindirizzopartenza: TJSHTMLInputElement;
    idfruitore2: TJSHTMLInputElement;
    dsfruitore2: TJSHTMLInputElement;
    dsindirizzoarrivo: TJSHTMLInputElement;
    dstelefono: TJSHTMLInputElement;
    dsnote: TJSHTMLInputElement;
    mofifica:TJSHTMLButtonElement;
    chiudi:TJSHTMLButtonElement;
  end;

implementation

{$R *.html}

{ TFrmVisitemodifica }

procedure TFrmVisitemodifica.AfterRender;
begin

 //

end;

procedure TFrmVisitemodifica.AfterDomAppend;
begin

      Await(CompilaCampi);

end;

procedure TFrmVisitemodifica.CompilaCampi;
begin

  QryTrasporti.Close;
  QryTrasporti.SQL.Text:= ' select dtdata, horaarrivo, idfruitore, dsfruitore, '
                      + ' dsindirizzopartenza, dstelefono, dsnote, '
                      + ' idfruitore2, dsfruitore2, dsindirizzoarrivo '
                      + ' from ta_trasporti '
                      + ' where idtrasporto = ' + IntToStr(idtrasporto);
  AWait(QryTrasporti.Open);

  // compilazione dati
  dtdata.value := Copy(QryTrasporti.FieldByName('dtdata').AsString,7,4) +'-'+
        Copy(QryTrasporti.FieldByName('dtdata').AsString,4,2) +'-'+
        Copy(QryTrasporti.FieldByName('dtdata').AsString,1,2);
  horaarrivo.value := QryTrasporti.FieldByName('HORAARRIVO').AsString;
  idfruitore.value := QryTrasporti.FieldByName('IDFRUITORE').AsString;
  dsfruitore.value := QryTrasporti.FieldByName('DSFRUITORE').AsString;
  dsindirizzopartenza.value := QryTrasporti.FieldByName('DSINDIRIZZOPARTENZA').AsString;
  idfruitore2.value := QryTrasporti.FieldByName('IDFRUITORE2').AsString;
  dsfruitore2.value := QryTrasporti.FieldByName('DSFRUITORE2').AsString;
  dsindirizzoarrivo.value :=  QryTrasporti.FieldByName('DSINDIRIZZOARRIVO').AsString;
  dstelefono.value := QryTrasporti.FieldByName('DSTELEFONO').AsString;
  dsnote.value := QryTrasporti.FieldByName('DSNOTE').AsString;

end;

procedure TFrmVisitemodifica.modifica_click(Event: TJSEvent);
var
  DataVisita: String;
  SQL: String;
  IDFruitoreSQL: String;
  IDFruitore2SQL: String;
begin
  // 1. Validazione campi obbligatori
  if Trim(dtdata.value) = '' then
  begin
    ShowMessage('La data è obbligatoria');
    Exit;
  end;

  if Trim(horaarrivo.value) = '' then
  begin
    ShowMessage('L''ora è obbligatoria');
    Exit;
  end;

  try
    // 2. Data nel formato YYYY-MM-DD
    DataVisita := Copy(dtdata.value, 1, 10);

    // 3. ID primo fruitore
    // Se vuoto -> NULL
    if Trim(idfruitore.value) = '' then
      IDFruitoreSQL := 'NULL'
    else
      IDFruitoreSQL := idfruitore.value;

    // 4. ID secondo fruitore
    // Se vuoto -> NULL
    if Trim(idfruitore2.value) = '' then
      IDFruitore2SQL := 'NULL'
    else
      IDFruitore2SQL := idfruitore2.value;

    // 5. Costruzione UPDATE
    SQL :=
        'UPDATE TA_TRASPORTI SET '
      + 'DTDATA = DATE ' + QuotedStr(DataVisita) + ', '
      + 'HORAARRIVO = ' + QuotedStr(horaarrivo.value) + ', '
      + 'IDFRUITORE = ' + IDFruitoreSQL + ', '
      + 'DSFRUITORE = ' + QuotedStr(dsfruitore.value) + ', '
      + 'DSINDIRIZZOPARTENZA = ' + QuotedStr(dsindirizzopartenza.value) + ', '
      + 'IDFRUITORE2 = ' + IDFruitore2SQL + ', '
      + 'DSFRUITORE2 = ' + QuotedStr(dsfruitore2.value) + ', '
      + 'DSINDIRIZZOARRIVO = ' + QuotedStr(dsindirizzoarrivo.value) + ', '
      + 'DSTELEFONO = ' + QuotedStr(dstelefono.value) + ', '
      + 'DSNOTE = ' + QuotedStr(dsnote.value) + ', '
      + 'DTINSERIMENTO = CURRENT_DATE'
      + ' WHERE IDTRASPORTO = ' + IntToStr(idtrasporto);

    // 6. Esecuzione UPDATE
    QryTrasporti.SQL.Text := SQL;

    await(QryTrasporti.ExecuteSql);

    // 7. Conferma
    ShowMessage(
      'Modifica eseguita con successo.'
    );

    Close();

  except
    on E: Exception do
    begin
      ShowMessage(
        'Errore durante la modifica:' +
        #13#10 +
        E.Message
      );
    end;
  end;
end;


procedure TFrmVisitemodifica.chiudi_click(Event: TJSEvent);
begin

  Close;

end;

procedure TFrmVisitemodifica.idfruitore_click;
begin
  
  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= ' select idanagrafica, dsragionesociale, '
       + ' dsindirizzo ||'' - ''|| dslocalita ||'' - ''|| dsprovincia as indirizzo, '
       + ' dstelefono, dsnote '
       + ' from an_anagrafiche ';
      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      idfruitore.value := QrySeleziona.FieldByName('idanagrafica').AsString;
      dsfruitore.value := QrySeleziona.FieldByName('dsragionesociale').AsString;
      dsindirizzopartenza.value := QrySeleziona.FieldByName('indirizzo').AsString;
      dstelefono.value := QrySeleziona.FieldByName('dstelefono').AsString;
      dsnote.value := QrySeleziona.FieldByName('dsnote').AsString;
    end;
  end;

end;

procedure TFrmVisitemodifica.idfruitore2_click;
begin

  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= ' select idanagrafica, dsragionesociale, '
       + ' dsindirizzo ||'' - ''|| dslocalita ||'' - ''|| dsprovincia as indirizzo '
       + ' from an_anagrafiche ';
      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      idfruitore2.value := QrySeleziona.FieldByName('idanagrafica').AsString;
      dsfruitore2.value := QrySeleziona.FieldByName('dsragionesociale').AsString;
      dsindirizzoarrivo.value := QrySeleziona.FieldByName('indirizzo').AsString;
    end;
  end;

end;

procedure TFrmVisitemodifica.elimina_click(Event: TJSEvent);
begin

    CompilaCampi;

    if not Window.Confirm('Vuoi procedere con l''eliminazione della visita?') then
      Exit;

    QryTrasporti.Close;
    QryTrasporti.SQL.Text := 'DELETE FROM TA_TRASPORTI ' +
                            'WHERE IDTRASPORTO = ' +
                            IntToStr(idtrasporto);

    AWait(QryTrasporti.ExecuteSql);

    ShowMessage('Eliminazione eseguita con successo');

    Close();

end;

initialization
  RegisterWeb(TFrmVisitemodifica);

end.

